<template>
  <div class="app-container bj-label-colon">
    <BjDivider right-fixed
      >{{ $t('routeBusinessStockDeliveryResultView.Basic') }}
      <template slot="right">
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <el-row>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Delivery')">
            {{ data.resultCode }}
            <BjCopyIcon class="ml10" :copy="data.resultCode" />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Outbound')">
            {{ data.outLogicWarehouseCode }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Name')">
            {{ data.outLogicWarehouseName }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Logistics')">
            {{ data.logisticCompany }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.business')">
            {{ data.logisticBusiness }}
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Consignee')">
            <BjDecrypt
              :row="data"
              row-key="receiverNameMask"
              :channel="data.channelTypeCode"
              :type="ORDER_DECRYPT_NAME['receiverNameMask']"
              :order-sn="data.orderCode"
              inner
            />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Contact')">
            <BjDecrypt
              :row="data"
              row-key="receiverPhoneMask"
              :channel="data.channelTypeCode"
              :type="ORDER_DECRYPT_NAME['receiverPhoneMask']"
              :order-sn="data.orderCode"
              inner
            />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Shipping')">
            <BjDecrypt
              :row="data"
              row-key="addressMask"
              :channel="data.channelTypeCode"
              :type="ORDER_DECRYPT_NAME['addressMask']"
              :order-sn="data.orderCode"
              inner
            />
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Creation')">
            {{ data.creationDate }}
          </el-form-item>
          <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Created')">
            {{ data.createdName }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <BjDivider>{{ $t('routeBusinessStockDeliveryResultView.Associated') }}</BjDivider>
    <el-form inline>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryResultView.Doc')">
          {{ data.shippingNo }}
          <BjCopyIcon v-if="data.shippingNo" class="ml10" :copy="data.shippingNo" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryResultView.notice')">
          <span
            class="link"
            @click="$toPage('BusinessStockDeliveryInformView', { id: data.odoId })"
            >{{ data.odoCode }}</span
          >
          <BjCopyIcon v-if="data.odoCode" class="ml10" :copy="data.odoCode" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('routeBusinessStockDeliveryResultView.WMS')">
          {{ data.wmsCode }}
          <BjCopyIcon v-if="data.wmsCode" class="ml10" :copy="data.odowmsCodeCode" />
        </el-form-item>
      </el-col>
    </el-form>
    <BjDivider>{{ $t('routeBusinessStockDeliveryResultView.Product') }}</BjDivider>
    <!-- TODO:商品明细应该只有一条 by skyer-ebc-325 -->
    <BjPage
      ref="BjPage"
      :col-span="colSpan"
      :get-action="queryApi"
      :query-params="queryParams"
      :serial="serial"
      :selection="false"
      :stripe="false"
      search-btn-hide
      right-toolbar-hide
      row-key="id"
      no-auto-height
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm> </template>
      <template #startBtnGroup>
        <!-- <el-button type="primary">解挂</el-button> -->
      </template>
      <template v-slot:tableColumn>
        <!-- <el-table-column :label="$t('goodsPage.spuCode')" prop="spuCode" align="center" /> -->
        <el-table-column :label="$t('routeBusinessStockDeliveryResultView.SKU')" prop="skuName" align="center" />
        <el-table-column :label="$t('routeBusinessStockDeliveryResultView.SKUcode')" prop="skuCode" align="center" />
        <el-table-column :label="$t('routeBusinessStockDeliveryResultView.Quantity')" prop="realNum" align="center" />
        <!-- <el-table-column :label="$t('goodsPage.spuName')" prop="spuName" align="center" /> -->
      </template>
      <template #paginationLeft>
        <span class="ml20">{{ $t('routeBusinessStockDeliveryResultView.Shipped') }}{{ qtyData.alreadyOutQty }}</span>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
import { ORDER_STOCK_OUT_TYPE_LIST, ORDER_DECRYPT_NAME } from '@/utils/constants';
export default {
  name: 'BusinessStockDeliveryResultView',
  mixins: [pageMiXin, viewMiXin],
  props: {},
  data() {
    return {
      ORDER_STOCK_OUT_TYPE_LIST,
      ORDER_DECRYPT_NAME,
      queryApi: stockApi.getResultDetailPage,
      queryParams: {
        resultId: this.$route.query.id,
      },
      colSpan: 12,
      id: null,
      data: {},
      qtyData: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData(this.id);
  },
  mounted() {},
  methods: {
    getData(id) {
      stockApi
        .getResultRecordsDetail({ id })
        .then(res => {
          this.data = res;
        });
      stockApi
        .getResultDetailStatus({ resultId: id })
        .then(res => {
          this.qtyData = res;
        });
    },
    handleClose() {
      this.cancel();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item {
  margin-bottom: 5px;
}
</style>
